import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icon" }

import Popper from "vue3-popper";
import { InfoOutlined } from "@vicons/material";
import { NIcon } from "naive-ui";

import { defineComponent } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  setup(__props) {

defineComponent({
  name: "Tooltip",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popper), { arrow: "" }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(NIcon), { size: "24" }, {
          default: _withCtx(() => [
            _createVNode(_unref(InfoOutlined))
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }))
}
}

})